<template>
    <div class="import-page-wrap">
        <div class="back-wrap">
            <span class="back-icon" @click="handleBack"><i class="el-icon-arrow-left"></i>返回</span>
            <span class="back-title">导入花名册</span>
        </div>
        <div class="import-page-main flex">
            <div class="import-page-aside">
                <ul>
                    <li class="flex" v-for="(item, index) in stepList" :key="index">
                        <i class="step-icon"></i>
                        <div>
                            <p class="list-title">{{ item.title }}</p>
                            <p v-for="(sepcItem, sepcIndex) in item.content" :key="sepcIndex">{{ sepcItem }}</p>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="import-page-content">
                <template v-if="importstate == 3 || importstate == 4">
                    <div class="download-tip download-tip-warn" v-if="importstate == 3">
                        <i class="iconfont icon-jinggao"></i>
                        <span
                            >文件[批量添加人员模版.xlsx]中有4个表头需手动匹配，<i class="txt-danger">*</i
                            >必填字段必须匹配，非必填字段未匹配也可导入数据</span
                        >
                    </div>
                    <div class="download-tip download-tip-success" v-else>
                        <i class="el-icon-success iconfont"></i>
                        <span>全部表头全匹配，请注意查看格式标准是否正确</span>
                    </div>
                    <div class="table-wrap">
                        <custom-vxe-table border :max-height="800" :table-data="import_travel" :showPagination="false">
                            <vxe-column field="field" title="员工字段">
                                <template #header>
                                    <span>员工字段</span>
                                    <el-tooltip
                                        class="item"
                                        effect="dark"
                                        content="鼠标移入下方字段可查看正确格式"
                                        placement="top-start"
                                    >
                                        <i class="iconfont icon-bangzhuzhongxin"></i>
                                    </el-tooltip>
                                </template>
                                <template #default="{ row, rowIndex }">
                                    <i class="txt-danger" v-if="row.isRequired">*</i>
                                    <span>{{ row.field }}</span>
                                </template>
                            </vxe-column>
                            <vxe-column field="excelField" title="ExceL表头">
                                <template #default="{ row, rowIndex }">
                                    <span v-if="row.fit">{{ row.excelfield }}</span>
                                    <span v-else class="txt-danger">未匹配</span>
                                </template>
                            </vxe-column>
                            <vxe-column field="classify" title="格式标准">
                                <template #header>
                                    <span>格式标准</span>
                                    <el-tooltip class="item" effect="dark" placement="top-start">
                                        <div slot="content" style="text-align: center">
                                            <span>当显示格式不正确时</span><br /><span>鼠标移入可查看问题所在</span>
                                        </div>
                                        <i class="iconfont icon-bangzhuzhongxin"></i>
                                    </el-tooltip>
                                </template>
                                <template #default="{ row, rowIndex }">
                                    <span v-if="!row.fit">--</span>
                                    <span v-else-if="row.classify">格式正确</span>
                                    <span v-else class="txt-warn">格式不正确</span>
                                </template>
                            </vxe-column>
                            <vxe-column title="操作" width="84">
                                <template #default="{ row, rowIndex }">
                                    <el-button type="text" @click="handleClickSelectField(row)">选择字段</el-button>
                                </template>
                            </vxe-column>
                        </custom-vxe-table>
                        <el-button type="text" class="add-btn" @click="handleAddField"
                            ><i class="el-icon-plus"></i>新增字段</el-button
                        >
                    </div>
                </template>
                <template v-else>
                    <div class="download-tip" v-if="importstate == 0 || importstate == 1">
                        <i></i>
                        <span>下载【标准模版】，修改后上传；或直接上传花名册Excel文件，系统将自动匹配相关字段 </span>
                        <el-button>下载模版</el-button>
                    </div>
                    <div class="download-tip download-tip-success" v-if="importstate == 2">
                        <i class="el-icon-success iconfont"></i>
                        <span>导入成功</span>
                    </div>
                    <div class="download-wrap">
                        <template v-if="importstate == 0">
                            <el-upload
                                class="upload-btn"
                                accept=".xlsx"
                                :on-success="handleSuccess"
                                :before-upload="beforeUpload"
                                drag
                                action="https://jsonplaceholder.typicode.com/posts/"
                            ></el-upload>
                            <img
                                class="download-icon"
                                src="https://download.hecoos.com/enlightv/2025-09/09e1d19dc6a5b669df18f4f29eda6a98.png"
                                alt=""
                            />
                            <p>将文件拖拽至此，也可以<el-button type="text">【点击上传】</el-button></p>
                        </template>
                        <template v-if="importstate == 1">
                            <img
                                v-if="import_percentage < 100"
                                class="download-icon"
                                src="https://download.hecoos.com/enlightv/2024-42/145324bb3de7bade655b3543df7510a3.png"
                                alt=""
                            />
                            <div class="import_wrap_percentage">
                                <el-progress
                                    :percentage="import_percentage"
                                    :stroke-width="14"
                                    :text-inside="true"
                                ></el-progress>
                            </div>
                            <div
                                class="upload-text"
                                v-text="import_percentage == 100 ? '文件导入完成' : '文件导入中  请稍等...'"
                            ></div>
                        </template>
                        <template v-if="importstate == 2">
                            <img
                                class="download-icon"
                                src="https://download.hecoos.com/enlightv/2024-42/145324bb3de7bade655b3543df7510a3.png"
                                alt=""
                            />
                            <div class="import_wrap_percentage">
                                <el-progress
                                    :percentage="import_percentage"
                                    :stroke-width="14"
                                    :text-inside="true"
                                ></el-progress>
                            </div>
                            <div class="upload-text">
                                已导入20条数据，其中18条为新增人员，2条重复人员数据，重复人员信息已覆盖更新
                            </div>
                        </template>
                    </div>
                </template>
                <div class="table-footer-btn" v-if="importstate == 3 || importstate == 4">
                    <el-button type="primary" plain>重新导入</el-button>
                    <el-button type="primary" @click="handleSubmitData">上传数据</el-button>
                </div>
                <el-button type="primary" v-if="importstate == 2" class="custom-primary-btn" @click="handleBack"
                    >确定</el-button
                >
            </div>
        </div>
        <el-dialog
            title="新增字段"
            :visible.sync="dialogAddFieldVisible"
            width="520px"
            :before-close="handleFieldDialogClose"
            :close-on-click-modal="false"
            class="custom-form-dialog"
        >
            <el-form ref="formData" :rules="formRules" :model="formData" label-position="top">
                <el-form-item label="字段类型" prop="type">
                    <el-select placeholder="请选择字段类型" v-model="formData.type">
                        <el-option
                            v-for="(item, index) in fieldTypeList"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click.stop="handleFieldDialogClose">取消</el-button>
                <el-button type="primary" @click.stop="handleFieldDialogConfirm">确定</el-button>
            </span>
        </el-dialog>
        <fieldSelect ref="fieldSelect" @submit="onSelectFieldCallback" />
        <el-dialog
            title=""
            :visible.sync="submitTipDialog"
            width="390px"
            :before-close="handleSubmitTipDialogClose"
            :close-on-click-modal="false"
            class="custom-dialog custom-tooltip-confirm-dialog"
        >
            <div class="flex">
                <i class="dialog-left-icon iconfont icon-jinggao dialog-icon-danger"></i>
                <div>
                    <p class="tooltip-confirm-title">
                        {{ submitTipTitle }}
                    </p>
                    <p>{{ submitTipContent }}</p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleSubmitTipDialogClose">取消</el-button>
                <el-button type="primary" v-if="submitTipStatus == 2" @click="handleSubmitTipDialogConfirm('upload')"
                    >上传数据</el-button
                >
                <el-button type="primary" v-else
                    >重新上传
                    <el-upload
                        class="upload-btn"
                        accept=".xlsx"
                        :on-success="handleSuccess"
                        :before-upload="beforeUpload"
                        drag
                        action="https://jsonplaceholder.typicode.com/posts/"
                    ></el-upload
                ></el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import CustomVxeTable from "@/components/pComponents/vxe-table";
import fieldSelect from "./component/field_select.vue";
export default {
    name: "importRoster",
    components: { CustomVxeTable, fieldSelect },
    data() {
        return {
            stepList: [
                { title: "上传文件", content: ["通过Excel文件导入人员数据"] },
                { title: "匹配列表数据", content: ["将表格中的表头", "及格式与系统内的字段关联"] },
                { title: "导入数据", content: ["将文件中的人员数据导入系统"] },
            ],
            import_travel: [
                {
                    field: "姓名",
                    excelfield: "姓名",
                    fit: true,
                    classify: true,
                    classifyLabel: "格式正确",
                    isRequired: true,
                },
                {
                    field: "手机号",
                    excelfield: "联系方式",
                    fit: false,
                    classify: false,
                    classifyLabel: "",
                    isRequired: true,
                },
                {
                    field: "性别",
                    excelfield: "男/女",
                    fit: false,
                    classify: false,
                    classifyLabel: "",
                    isRequired: false,
                },
                {
                    field: "部门",
                    excelfield: "部门",
                    fit: true,
                    classify: false,
                    classifyLabel: "格式不正确",
                    isRequired: false,
                },
            ], // 批量上传有问题的数据
            importstate: 0, //== 0 还没导入，== 1导入中， == 2导入成功 , ==3导入失败，数据不匹配，==4数据匹配
            import_percentage: 0,
            import_msg: "",
            // 新建字段
            dialogAddFieldVisible: false,
            formRules: {
                type: [{ required: true, message: "请选择字段类型" }],
            },
            formData: {
                type: "",
            },
            fieldTypeList: [
                { label: "必填", value: 1 },
                { label: "下拉选择", value: 2 },
                { label: "单选", value: 3 },
            ],
            // 上传数据结果提示框
            submitTipDialog: false,
            submitTipStatus: 0, //0-字段未匹配，1-数据格式不正确，2-上传数据
            submitTipTitle: "系统字段未匹配",
            submitTipContent: "必填字段未匹配，请重新上传文件！",
        };
    },
    methods: {
        handleBack() {
            this.$router.back();
        },
        handleSuccess(response) {
            // 文件上传成功的回调函数
            console.log(response, "文件====");
            this.import_percentage = 0;
            this.importstate = 2;
            const timer = setInterval(() => {
                if (this.import_percentage < 90) {
                    this.import_percentage += 10;
                }
            }, 200);

            setTimeout(() => {
                this.importstate = 2;
                this.import_percentage = 100;
                // UserUpload({
                //     file_path: response.src
                // }).then(res => {
                //     if (res.code == 200) {
                //         this.importstate = 2
                //         this.import_percentage = 100
                //     } else {
                //         this.import_travel = res.data ? res.data : []
                //         if (res.messgae) {
                //             this.import_msg = res.messgae
                //         }
                //         this.importstate = 3
                //     }
                // })
            }, 2000);
        },
        beforeUpload(file) {
            // 文件上传前的钩子函数
            console.log(file);
        },
        handleAddField() {
            this.handleFieldDialogShow();
        },
        handleFieldDialogShow() {
            this.dialogAddFieldVisible = true;
        },
        handleFieldDialogClose() {
            this.$refs.formData.clearValidate();
            this.$refs.formData.resetFields();
            this.dialogAddFieldVisible = false;
        },
        handleFieldDialogConfirm() {
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    console.log("校验成功");
                }
            });
        },
        // 选择字段
        handleClickSelectField(row) {
            this.$refs.fieldSelect.handleSelecetFieldShow(row);
        },
        onSelectFieldCallback() {},
        handleSubmitTipDialogClose() {
            this.submitTipDialog = false;
            // this.submitTipStatus = ""
            // this.submitTipTitle = ""
            // this.submitTipContent = ""
        },
        // 上传数据
        handleSubmitTipDialogConfirm(type) {
            if (type == "upload") {
                // 上传数据
            } else {
                this.handleSubmitTipDialogClose();
            }
        },
        // 上传数据
        handleSubmitData() {
            this.submitTipStatus = 0;
            this.submitTipDialog = true;
        },
    },
};
</script>
<style lang="scss" scoped>
.import-page-wrap {
    height: 100%;

    .back-wrap {
        padding: 12px 0 12px 18px;
        border-bottom: 1px solid rgba(232, 232, 232, 1);
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 24px;
        color: rgba(102, 102, 102, 1);
        display: flex;
        align-items: center;

        .back-icon {
            border-radius: 4px;
            cursor: pointer;

            &:hover {
                background-color: rgba(0, 0, 0, 0.04);
                color: rgba(51, 51, 51, 1);
            }
        }

        .back-title {
            font-weight: 700;
            color: rgba(51, 51, 51, 1);
            padding-left: 17px;
            position: relative;

            &::before {
                content: "";
                position: absolute;
                left: 8px;
                top: 4px;
                width: 1px;
                height: 16px;
                background: rgba(232, 232, 232, 1);
            }
        }
    }

    .import-page-main {
        height: calc(100% - 49px);

        .import-page-aside {
            width: 246px;
            background: rgba(0, 0, 0, 0.04);
            padding: 114px 30px 0;

            ul {
                position: relative;

                &::before {
                    content: "";
                    display: block;
                    position: absolute;
                    left: 8px;
                    top: 11px;
                    width: 1px;
                    height: 178px;
                    background: rgba(217, 217, 217, 1);
                }
            }

            li {
                margin-bottom: 36px;

                .step-icon {
                    display: block;
                    width: 16px;
                    height: 16px;
                    border-radius: 50%;
                    background: rgba(25, 144, 255, 1);
                    position: relative;
                    margin-right: 12px;
                    margin-top: 3px;
                    flex-shrink: 0;

                    &::before {
                        content: "";
                        position: absolute;
                        top: 4px;
                        left: 4px;
                        width: 8px;
                        height: 8px;
                        border-radius: 50%;
                        background: rgba(255, 255, 255, 1);
                    }
                }

                p {
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    color: rgba(102, 102, 102, 1);
                }

                .list-title {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                    margin-bottom: 4px;
                }
            }
        }
    }

    .import-page-content {
        padding: 24px 24px 0 26px;
        flex: 1;
        position: relative;
    }

    .download-tip {
        width: 100%;
        height: 54px;
        border-radius: 8px;
        background: rgba(203, 225, 245, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(25, 144, 255, 1);

        & > .iconfont {
            margin-right: 8px;
        }

        .el-button {
            margin-left: 8px;
            padding: 0;
            width: 88px;
            height: 32px;
            opacity: 1;
            border-radius: 52px;
            background: rgba(255, 255, 255, 1);

            border: 1px solid rgba(25, 144, 255, 1);
            text-align: center;
            line-height: 32px;
            color: rgba(25, 144, 255, 1);
            font-weight: 400;
        }

        &.download-tip-warn {
            background-color: rgba(252, 238, 214, 1);
            color: rgba(240, 170, 50, 1);

            .icon-jinggao {
                color: rgba(240, 170, 50, 1);
            }
        }
        &.download-tip-success {
            background: rgba(222, 240, 214, 1);
            color: rgba(90, 179, 51, 1);
            i {
                color: rgba(90, 179, 51, 1);
                font-size: 16px;
            }
        }
    }

    .download-wrap {
        margin-top: 36px;
        width: 100%;
        height: 582px;
        border-radius: 8px;
        background: rgba(247, 248, 250, 1);
        border: 2px dashed rgba(217, 217, 217, 1);
        box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03);
        padding-top: 148px;
        text-align: center;
        position: relative;

        .download-icon {
            width: 180px;
        }

        .import_wrap_percentage {
            width: 69.1%;
            margin: 16px auto;
        }

        .upload-text {
            font-size: 18px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 28px;
            color: rgba(51, 51, 51, 1);
            text-align: center;
        }
    }

    .upload-btn {
        width: 240px;
        height: 160px;
        display: block;
        z-index: 20;
        opacity: 0;
        cursor: pointer;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);

        .el-upload {
            display: block;
            width: 100%;
            height: 100%;
        }
    }

    .table-wrap {
        .icon-bangzhuzhongxin {
            margin-left: 4px;
            padding: 4px;
            font-size: 14px;
            border-radius: 4px;
            color: rgba(102, 102, 102, 1);
            cursor: pointer;

            &:hover {
                background-color: rgba(0, 0, 0, 0.04);
                color: rgba(51, 51, 51, 1);
            }
        }

        .el-button--text {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            color: rgba(25, 144, 255, 1);
            line-height: 22px;
        }

        .txt-danger {
            margin-right: 2px;
        }

        .add-btn {
            padding: 16px 0;
            color: rgba(41, 144, 255, 1);

            .el-icon-plus {
                margin-right: 8px;
            }

            &:hover {
                color: rgba(75, 162, 255, 1);
            }

            &:active {
                color: rgba(34, 121, 214, 1);
            }
        }
    }

    .txt-danger {
        color: rgba(228, 65, 68, 1);
    }

    .txt-warn {
        color: rgba(240, 170, 50, 1);
    }

    .table-footer-btn {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 10px 24px;
        text-align: center;
        border-radius: 0px 0px, 8px, 8px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px -2px 4px -2px rgba(0, 0, 0, 0.08);

        .el-button {
            font-weight: 400;
            padding: 4px 15px;
            line-height: 22px;

            &.el-button--primary.is-plain {
                border-color: rgba(41, 144, 255, 1);
                background-color: transparent;
                color: rgba(41, 144, 255, 1);
            }
        }
    }
}
.custom-primary-btn {
    width: 126px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    text-align: center;
    line-height: 32px;
    padding: 0;
    margin-top: 36px;
    margin-left: 50%;
    transform: translateX(-50%);
}
</style>
<style lang="scss">
.custom-tooltip-confirm-dialog {
    .el-button {
        position: relative;
    }
}
</style>
